import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {ItemModel} from '@syncfusion/ej2-angular-splitbuttons';
import {UserService} from "../../services/user/user.service";
import {InternationalizationService} from "../../services/internationalization/internationalization.service";

export type LocaleOnChangeCallback = (newLocale: string, oldLocale: string) => void;

@Component({
  selector: 'sb-locale-selector',
  templateUrl: './locale-selector.component.html',
  styleUrls: ['./locale-selector.component.scss'],
})
export class LocaleSelectorComponent implements OnInit, AfterViewInit {

  @Input()
  public onChangeCallback: LocaleOnChangeCallback;

  public dropdownItems: ItemModel[] = [];

  public value: string = "";

  public multilingual = false;

  constructor(private userService: UserService, private i18nService: InternationalizationService) {
  }

  ngOnInit(): void {
    this.multilingual = this.userService.isMultilingual();
  }

  async ngAfterViewInit() {
    const locales = await this.loadLocales();
  }

  valueClass(locale: string): string {
      return `fi fi-${locale.toLowerCase().split('_')[1]}`;
  }

  setLocale(value: string) {
    const newLocale = value;
    const oldLocale = this.i18nService.getActiveLocale();

    const callback = this.onChangeCallback || this.defaultOnChangeCallback.bind(this);

    callback(newLocale, oldLocale);
  }

  defaultOnChangeCallback(newLocale: string, oldLocale: string) {
    if (newLocale != oldLocale) {
      this.i18nService.loadLocale(newLocale);
      this.i18nService.setLocale(newLocale, true);
      this.loadLocales();

      // We basically always need to reload after a locale change
      window.location.reload();
    }
  }

  async loadLocales() {
    if (this.multilingual) {
      const userLocale = this.userService.getLanguage();

      const locales = await this.i18nService.getLocales();

      this.dropdownItems = locales
        .sort((a, b) => (a.i18nKey.toLowerCase() > b.i18nKey.toLowerCase() ? 1 : -1))
        .map((kv) => ({
          id: kv.value,
          text: kv.i18nKey,
          iconCss: this.valueClass(kv.value),
        }));

      this.value = this.i18nService.getActiveLocale();
    }
  }
}
